import { createSlice } from '@reduxjs/toolkit';
import axios from '../../services/authService';
import { API_ENDPOINTS } from '../../config/apiConfig';
import { parseApiResponse } from '../../utilities/parseApiResponse';

export const createTestFlowSlice = createSlice({
  name: 'createTestFlow',
  initialState: {
    response: {},
    loading: false,
    error: null,
  },
  reducers: {
    reset: (state) => {
      state.response = {};
      state.loading = false;
      state.error = null;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    createTestFlowResponse: (state, action) => {
      state.response = action.payload;
      state.loading = false;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const { reset, setLoading, setError } = createTestFlowSlice.actions;

const { createTestFlowResponse } = createTestFlowSlice.actions;

export const createTestFlowAsync = (data) => async (dispatch) => {
  dispatch(reset());
  dispatch(setLoading(true));

  try {
    const payload = [
      {
        section_data: 'test-flows',
        market_id: data.market || 5,
        name: data.name,
        description: data.description,
        test_case_id: data.test_case_id || null,
      },
    ];

    const res = await axios.post(API_ENDPOINTS.INSERT_TEST_FLOW, payload);

    // Parse the response to get the actual flow ID
    let flowId = null;
    const parsedBody = parseApiResponse(res);
    if (parsedBody?.resDataObject?.test_flows?.length > 0) {
      flowId = parsedBody.resDataObject.test_flows[0];
    }

    const responseWithId = {
      ...res.data,
      flowId: flowId,
    };

    dispatch(createTestFlowResponse(responseWithId));
    return { success: true, data: responseWithId, flowId: flowId };
  } catch (err) {
    const errorMessage = err.response?.data?.message || err.message || 'Failed to create flow';
    console.error('Error creating test flow:', errorMessage);
    dispatch(setError(errorMessage));
    return { success: false, error: errorMessage };
  }
};

export const selectCreateTestFlowResponse = (state) => state.createTestFlow.response;
export const selectCreateTestFlowLoading = (state) => state.createTestFlow.loading;
export const selectCreateTestFlowError = (state) => state.createTestFlow.error;

export default createTestFlowSlice.reducer;
